import styled from 'styled-components';

import { theme } from '../../../../common/ui/theme';

interface TimelineLineProps {
    isFirst: boolean;
    isLast: boolean;
    isCurrentPort: boolean;
}

export const TimelineLine = styled.div<TimelineLineProps>`
    position: absolute;
    width: 6px;
    left: 50%;
    transform: translateX(-50%);
    top: ${({ isFirst }) => (isFirst ? '-40px' : '0')};
    bottom: ${({ isLast }) => (isLast ? '0' : '-8px')};

    ${({ isFirst, isLast, isCurrentPort }) => {
        if (isFirst && isLast) {
            if (isCurrentPort) {
                return `
                    background: linear-gradient(
                        to bottom,
                        transparent 0%,
                        ${theme.colors.accent.emphasis} 30px,
                        ${theme.colors.accent.emphasis} 64px,
                        ${theme.colors.background.inset} 64px,
                        ${theme.colors.background.inset} calc(100% - 30px),
                        transparent 100%
                    );
                `;
            }
            return `
                background: linear-gradient(
                    to bottom,
                    transparent 0%,
                    ${theme.colors.background.inset} 30px,
                    ${theme.colors.background.inset} calc(100% - 30px),
                    transparent 100%
                );
            `;
        }
        if (isFirst && isCurrentPort) {
            return `
                background: linear-gradient(
                    to bottom,
                    transparent 0%,
                    ${theme.colors.accent.emphasis} 30px,
                    ${theme.colors.accent.emphasis} 64px,
                    ${theme.colors.background.inset} 64px,
                    ${theme.colors.background.inset} 100%
                );
            `;
        }
        if (isFirst) {
            return `
                background: linear-gradient(
                    to bottom,
                    transparent 0%,
                    ${theme.colors.background.inset} 30px,
                    ${theme.colors.background.inset} 100%
                );
            `;
        }
        if (isLast) {
            return `
                background: linear-gradient(
                    to bottom,
                    ${theme.colors.background.inset} 0%,
                    ${theme.colors.background.inset} calc(100% - 30px),
                    transparent 100%
                );
            `;
        }
        return `
            background-color: ${theme.colors.background.inset};
        `;
    }}
`;
